import { render } from "./DashboardTile.vue?vue&type=template&id=f7328f72&ts=true"
import script from "./DashboardTile.vue?vue&type=script&lang=ts"
export * from "./DashboardTile.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__